import CapaSeiModel from "@/models/capaSeiModel";

import nfetch from "../utils/events/nfetch";

export default class CapaSEIService {
    private controllerName = "CapaSEI";

    public get(): Promise<Response> {
        return nfetch(`/${this.controllerName}/Get`, {
            credentials: "same-origin",
        });
    }

    public insertUpdate(model: CapaSeiModel): Promise<Response> {
        return nfetch(`/${this.controllerName}/InsertUpdate`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(model),
        });
    }
}
